import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Button, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons';
import { CSVLink } from 'react-csv';
import moment from 'moment';

//Context
import { useAuth } from '../../../context/auth';
import CardRelatorio from '../components/CardRelatorio';
import MainCard from '../../../components/MainCard/MainCard';


export default function RelatorioRedestinacoesDestino({ dadosRelatorio, btnVoltar, filtros }) {
    const { setupVariavel, session } = useAuth();

    //Referencia do relatorio para impressão pdf
    const refRelatorio = useRef(null);

    //Referencia do relatorio para download do csv
    const exportRef = useRef(null);

    //Botão de exportação csv
    const BtnExportCsv = () => {
        return (
            <Button className='mb-3' color='success' onClick={() => exportRef.current.link.click()}>
                <FontAwesomeIcon icon={faFileCsv} /> Gerar CSV
            </Button>
        )
    }

    //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
    const headersRedestinacoes = [
        { value: "Data Registro", objectValue: "dataRegistro", col: "6" },
        { value: "Status", objectValue: "status", col: "6" },
        { value: "Transportador", objectValue: "transportadorFantasia", col: "6" },
        { value: "Veiculo", objectValue: "placaVeiculo", col: "6" },
        { value: "Data Coleta", objectValue: "dataColeta", col: "6" },
        { value: "Destino Final", objectValue: "destinoFinal", col: "6" },
        { value: "Data Entrada", objectValue: "dataEntrada", col: "12" },
        { value: "Peso Entrada", objectValue: "pesoEntrada", col: "6" },
        { value: "Peso Saida", objectValue: "pesoSaida", col: "6" }
    ];

    const headersCSV = [
        { label: "Destino Origem", key: "destinoOrigem" },
        { label: "Destino Recebimento", key: "destinoRecebimento" },
        { label: "Transportador", key: "transportador" },
        { label: "Placa", key: "placa" },
        { label: "Data Coleta", key: "dataColeta" },
        { label: "Residuo", key: "residuo" },
        { label: "Peso", key: "peso" }
    ]

    //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
    const headersModalidade = [
        { value: "Descrição", objectValue: "descricao", col: "6" },
        { value: "Peso Destinado", objectValue: "pesoDestinado", col: "6" }
    ];

    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Relatório de redestinações",
    });


    return (
        <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint} BtnAction1InTop={BtnExportCsv}>
            <CSVLink
                separator={";"}
                data={dadosRelatorio.relatorioRedestinacaoCSV}
                headers={headersCSV}
                filename="Relatorio de redestinação.csv"
                target="_blank" ref={exportRef}
            />

            <div className="mt-4 relatorio w-100" ref={refRelatorio}>
                <div className="print m-2 d-flex align-items-center justify-content-between">
                    <p>Emitido por: {session.nome}</p>
                    <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
                {setupVariavel?.logoTipo &&
                    <div className="d-flex align-items-center justify-content-center">
                        <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%' }} />
                    </div>
                }
                <div className="header">
                    <h4 className='text-black'>Relatório de redestinações</h4>
                    <Row>
                        <div className='col-4'>
                            <p><span className="fw-bold">Período:</span> {moment(filtros.dataInicial).format("DD/MM/YYYY")} à {moment(filtros.dataFinal).format("DD/MM/YYYY")}</p>
                        </div>
                    </Row>
                    <Row>
                        <div className='col-4'>
                            {filtros.destinoId_selected
                                ?
                                <p><span className="fw-bold">Destino:</span> {filtros.destinoId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Destino:</span> Todos</p>
                            }
                        </div>
                        <div className='col-4'>
                            {filtros.modalidadeId_selected
                                ?
                                <p><span className="fw-bold">Modalidade:</span> {filtros.modalidadeId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Modalidade:</span> Todas</p>
                            }
                        </div>
                    </Row>
                </div>
                <div className="body">
                    <CardRelatorio
                        headers={headersRedestinacoes}
                        items={dadosRelatorio.relatorioRedestinacoes}
                        subTabela={{ nomeArray: "relatorioRedestinacaoModalidades", headersArray: headersModalidade, titleLista: "Lista de modalidades" }}
                    />
                </div>
            </div>
        </MainCard>
    );
}
